/* eslint-disable */
(function (factory, window) {

  // define an AMD module that relies on 'leaflet'
  if (typeof define === 'function' && define.amd) {
    define(['leaflet'], factory);

    // define a Common JS module that relies on 'leaflet'
  } else if (typeof exports === 'object') {
    module.exports = factory(require('leaflet'));
  }

  // attach your plugin to the global 'L' variable
  if (typeof window !== 'undefined' && window.L) {
    window.L.Control.Key = factory(L);
    window.L.control.key = function() {
      return new window.L.Control.Key()
    };
  }
}(function (L) {
  return L.Control.extend({
    options: {
      position: 'topright',
      values: [],
    },
    initialize: function (options) {
      L.setOptions(this, options);
    },
    onAdd: function (map) {
      const key = L.DomUtil.create('div', 'leaflet-bar');
      key.style = 'background-color: white;padding: 5px';
      for (const v of this.options.values) {
        const container = L.DomUtil.create('div', '', key);
        const colorElement = L.DomUtil.create('span', '', container);
        try {
          colorElement.style = 'width:20px;height:20px;display:inline-block;border:1px solid #bababa';
          if (v.color) {
            colorElement.style = colorElement.style.cssText + `background-color: ${v.color};`;
          } else if (v.image) {
            colorElement.style = colorElement.style.cssText + `background-image: ${v.image};`;
          }
          const text = L.DomUtil.create('span', '', container);
          text.innerText = v.text;
          text.style = 'vertical-align:top;margin-left: 5px;display:inline-block;padding-top:2px;';
        } catch (e) {
          console.error(e);
        }
      }
      return key;
    }
  });
}, window));
